import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { from, switchMap, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { AuthService } from "../services/auth.service";

/**
 * Attaches Bearer token to outgoing requests.
 * On 401 from non-auth endpoints, attempts a single token refresh, then retries.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const token = auth.accessToken();

  const authReq = token
    ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : req;

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      const isAuthEndpoint =
        req.url.startsWith("auth/") || req.url.includes("/auth/");
      if (error.status === 401 && !isAuthEndpoint) {
        return from(auth.refreshToken()).pipe(
          switchMap((newToken) => {
            if (!newToken) return throwError(() => error);
            const retried = req.clone({
              setHeaders: { Authorization: `Bearer ${newToken}` },
            });
            return next(retried);
          }),
        );
      }
      return throwError(() => error);
    }),
  );
};
